query GetExchangeRates(
  $page: Int
  $limit: Int
  $currency: String
  $source: String
  $sortBy: String
) {
  exchangeRates(
    page: $page
    limit: $limit
    currency: $currency
    source: $source
    sortBy: $sortBy
  ) {
    collection {
      id
      baseCurrency
      currency
      rate
      source
      validFrom
      validTo
      externalId
      createdAt
      updatedAt
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
